/* Search */
export default (el) => {
    const body = document.querySelector('body');
    const searchOverlay = document.querySelector('.search-overlay');
    const searchForm = document.querySelector('.search__form');

    const toggleItem = (event) => {
        if (body.clientWidth >= 1460) {
            event.preventDefault();
            if (searchForm) {
                searchForm.querySelector('input').focus();
                searchForm.querySelector('input').select();
            } else {
                body.classList.toggle('-search-active');
                el.classList.toggle('-active');
                searchOverlay.querySelector('input').focus();
            }
        }
    };

    // Toggle item
    el.addEventListener('click', toggleItem);
};
